let BASE_URL = "";

if (process.env.NODE_ENV === "development") {
  BASE_URL = "http://localhost:3000";
} else if (process.env.NODE_ENV === "production") {
  BASE_URL = "https://app.ampliacapital.com.br";
}

BASE_URL += "/api";

const LOGIN = {
  POST_LOGIN: BASE_URL + "/login",
};

const LOAN = {
  GET_LOAN_BY_IDENTIFIER: "/form",
  GET_DOCUMENT_TYPES: "/document-types",
  GET_SEGMENTS: "/segments",
  UPLOAD_PARTIAL_FORM: "/form/upload-partial",
  UPLOAD_LOAN_DOCUMENT: "/form/upload-document",
  GET_ALL: "/loans",
  INVALIDATE_DOCUMENT: "/document/invalidate",
  GET_DASHBOARD_DATA: "/dashboard/data",
  GET_DASHBOARD_DAILY_DATA: "/dashboard/daily",
  CREATE_NEW: "/simulation-admin",
  PREPARE_SIGN: "/prepare-sign",
};

const DASHBOARD = {
  GET_ALL: `/dashboard`,
  GET_SUMMARY: `/dashboard/summary`,
  GET_PIPELINE: `/dashboard/pipeline`,
  GET_FORECAST: `/dashboard/forecast`,
  GET_VELOCITY: `/dashboard/velocity`,
  GET_SOURCES: `/dashboard/sources`,
  GET_LEADERBOARD: `/dashboard/leaderboard`,
  GET_FOLLOW_UPS: `/dashboard/follow-ups`,
  GET_RISKS: `/dashboard/risks`,
  GET_OPERATIONS: `/dashboard/operations`,
};

const API = {
  GET_TOKEN: "/get-api-rest-token",
};

const BLACKLIST = {
  GET_ALL: "/blacklists",
  GET: "/blacklist",
  SEARCH: "/blacklist/search",
};

const CATEGORIES = {
  GET_ALL: "/categories",
};

const COMPANY = {
  GET_PERMISSION_QUERIES: "/company/permission/queries",
  GET_DOCS: "/company/docs",
  GET_EXTERNAL_INFO: "/company/external-info",
};

const USERS = {
  GET_USERS: "/users",
  GET_USER: "/user",
  GET_USER_CURRENT: "/user-current",
  GET_USER_QUERY_PERMISSIONS: "/user-query/permission",
  GET_USER_BY_EMAIL: "/user/email",
};

const ADMIN = {
  GET_CUSTOMERS: "/admin/customers",
  GET_REPRESENTATIVES: "/admin/representatives",
  GET_COMPANY_QUERIES: "/admin/company/queries",
  GET_QUERIES: "/admin/queries",
  GET_USERS: "/admin/users",
  GET_PROVIDERS: "/admin/providers",
  GET_PROVIDERS_ALL: "/admin/providers-all",
  NEW_CUSTOMER: "/admin/customer/new",
  NEW_REPRESENTATIVE: "/admin/representative/new",
  GET_COMPANY_BY_INFO: "/admin/company/info",
  GET_COMPANY: "/admin/company",
  GET_COMPANY_QUERIES_HISTORY: "/admin/queries/company",
  GET_COMPANY_QUERIES_HISTORY_SIMPLIFIED: "/admin/queries/company/simplified",
  GET_PAYMENTS: "/admin/payments",
  GET_QUERY: "/admin/query",
  GET_TABLE_QUERIES: "/admin/table/queries",
  GET_TABLES: "/admin/tables",
  GET_TABLE: "/admin/table",
  GET_SURVEY_REPORT: "/admin/survey/company",
  GET_CUSTOMIZED_QUERY: "/admin/customized-query",
  GET_HISTORY_INVOICES: "/admin/invoices/history",
};

const CHARGES = {
  SEND: "/charge/send",
  GET_ALL: "/charges",
  GET: "/charge",
  GET_TYPES: "/charges/types",
};

const QUERIES = {
  GET_LOCALIZA_CNPJ: "/query/localiza-cnpj",
  GET_LAST_QUERIES: "/query/last",
  GET_LAST_7_DAYS_COUNT_QUERIES: "/query/total/last/7",
  GET_QUERIES_TOTAL: "/query/total",
  GET_QUERIES_LIST: "/queries",
  UPLOAD_PDF: "/query/upload/pdf",
  DOWNLOAD_PDF: "/query/download/pdf",
  GENERATE_PDF: "/generate/pdf",
  GET_DASHBOARD_INFOS: "/query/dashboard",
  GET_DASHBOARD_INFOS_REPRESENTATIVE: "/query/dashboard/representative",
  GET_DASHBOARD_INFOS_POWER_USER: "/query/dashboard/power-user",
  GET_V1_QUERY: "/v1",
  GET_V2_QUERY: "/v2",
  GET_USER_QUERY: "/query/user-query",
};

const QUERIES_VEICULAR = {
  GET_COMPLETA_VEICULAR: "/query/completa-veicular",
  GET_LEILAO_POSITIVO: "/query/leilao-positivo",
  GET_VEICULAR: "/query/veicular",
  GET_PRECIFICADOR: "/query/veicular/precificador",
  GET_BIN_NACIONAL: "/query/veicular/bin-nacional",
};

const AUDITS = {
  GET_AUDITS: "/audits",
};

const AVATAR = {
  UPLOAD: "/avatar/upload",
};

const PAYMENTS = {
  CREATE: "/payment/create",
  CREATE_PAYMENT_ADMIN: "/admin/payment/create",
  GET_ALL: "/invoices",
  ADD_CREDIT: "/payment/confirm",
  ADD_CREDIT_MANUALLY: "/payment/manually",
};

const REPORTS = {
  GET_COMPANY_QUERIES_HISTORY: "/report/queries/company",
  GET_COMPANY_QUERIES_HISTORY_SIMPLIFIED: "/report/queries/company/simplified",
};

const SURVEYS = {
  GET_SURVEY: "/survey",
  GET_ALL_SURVEY: "/surveys",
  GET_TAGS: "/survey/tags",
  GET_SURVEY_VEHICLE: "/survey/vehicle",
  GET_SURVEY_CHECKLIST: "/survey/checklist",
  GET_CHECKLIST: "/survey/questions",
  UPLOAD_IMAGE: "/survey/image/upload",
  GET_SURVEY_IMAGES: "/survey/images",
  GET_CONFIG: "/survey/configs",
  FINISH: "/survey/finish",
  GET_REPORT: "/survey/report",
  DELETE_IMAGE_SURVEY: "/survey/image/upload",
};

const CRM = {
  FUNNELS: "/crm/funnels",
  FUNNEL_DETAILS: "/crm/funnel",
  CREATE_FUNNEL: "/crm/funnels",
  UPDATE_FUNNEL: "/crm/funnels", // + /:funnelId
  DELETE_FUNNEL: "/crm/funnels", // + /:funnelId
  BANKS: "/crm/banks",

  CREATE_STAGE: "/crm/stages",
  UPDATE_STAGE: "/crm/stages", // + /:stageId
  DELETE_STAGE: "/crm/stages", // + /:stageId

  CREATE_CARD: "/crm/card",
  GET_CARD: "/crm/card",
  UPDATE_CARD: "/crm/card", // + /:cardId
  DELETE_CARD: "/crm/card", // + /:cardId

  ADD_CARD_HISTORY: "/crm/card", // + /:cardId/history
  GET_CARD_HISTORY: "/crm/card", // + /:cardId/history
  CREATE_TASK: "/crm/card", // + /:cardId/tasks
  LIST_TASKS: "/crm/card", // + /:cardId/tasks
  UPDATE_TASK: "/crm/task", // + /:taskId
  COMPLETE_TASK: "/crm/task", // + /:taskId/complete
  CANCEL_TASK: "/crm/task", // + /:taskId/cancel
  DELETE_TASK: "/crm/task", // + /:taskId
  POSTPONE_TASK: "/crm/tasks", // + /:taskId/postpone
  TODAY_TASKS: "/crm/tasks/today",
  DAILY_COMMITTEE_NOTE: "/crm/daily-committee-note",
};

const TAGS = {
  // Lista/pesquisa paginada: ?q=&limit=&offset=&orderBy=&order=
  LIST: (companyId) => `/companies/${companyId}/tags`,

  // Obter uma tag específica
  GET: (companyId, tagId) => `/companies/${companyId}/tags/${tagId}`,

  // Criar tag: { name, color }
  CREATE: (companyId) => `/companies/${companyId}/tags`,

  // Atualizar tag: { name?, color? }
  UPDATE: (companyId, tagId) => `/companies/${companyId}/tags/${tagId}`,

  // Remover tag
  DELETE: (companyId, tagId) => `/companies/${companyId}/tags/${tagId}`,

  // Upsert em massa: [{ name, color }, ...]
  BULK_UPSERT: (companyId) => `/companies/${companyId}/tags/bulk-upsert`,
};

const LEADS = {
  // CRUD/listagem
  LIST: "/leads", // GET ?page=&itemsPerPage=&search=&status=&ownerId=&tagId=&leadStageId=&companyId=&createdFrom=&createdTo=&lastContactFrom=&lastContactTo=&nextActionWindow=
  CREATE: "/leads", // POST
  GET: (id) => `/leads/${id}`, // GET
  UPDATE: (id) => `/leads/${id}`, // PATCH

  // utilidades
  BY_EMAIL: "/leads/by-email", // GET ?email=&companyId=

  // ações
  ASSIGN_OWNER: (id) => `/leads/${id}/assign-owner`, // PATCH { ownerId }
  NEXT_ACTION: (id) => `/leads/${id}/next-action`, // PATCH { nextAction, nextActionAt, notesAppend }
  STATUS: (id) => `/leads/${id}/status`, // PATCH { status, lostReason?, lostNotes? }
  CONVERT: (id) => `/leads/${id}/convert`, // PATCH { cardId }
  TAG: (id) => `/leads/${id}/tag`, // PATCH { tagId }
  CONSENT: (id) => `/leads/${id}/consent`, // PATCH { consentMarketing: boolean }

  // métricas
  STATS_BY_STATUS: "/leads/stats/status", // GET ?companyId= (se POWER_USER)
};

export {
  API,
  LOGIN,
  DASHBOARD,
  LOAN,
  BLACKLIST,
  CATEGORIES,
  COMPANY,
  USERS,
  ADMIN,
  CHARGES,
  QUERIES,
  QUERIES_VEICULAR,
  AUDITS,
  AVATAR,
  PAYMENTS,
  REPORTS,
  SURVEYS,
  CRM,
  TAGS,
  LEADS,
  BASE_URL,
};
